import React, { PropsWithChildren } from 'react';
import { ThemeProvider, useTheme } from 'styled-components';
import { updateThemeColumns } from '../../../helpers/columns';
import componentProps from '../../../helpers/componentProps';
import { applyComponentTheme } from '../../../theme';
import { GridItemProps, GridItemWrapper } from './styles';

/**
 * An item that should be aligned as per the fluid grid specified in the theme. Items must be added
 * within a **Grid component**.
 *
 * @param mobile  - the number of columns to span on mobile
 * @param tabletPortrait - the number of columns to span on portrait tablets
 * @param tabletLandscape - the number of columns to span on landscape tablets
 * @param desktop - the number of columns to span on desktop
 *
 * All values default to the number of columns for that breakpoint specified in the theme, i.e. full
 * parent width.
 *
 * Note that Grid/GridItems can be nested inside other Grid/GridItems, as the theme is updated inside
 * the GridItem to match the GridItem's width.
 */
const GridItem: React.FC<PropsWithChildren<GridItemProps>> = ({
  desktop,
  tabletLandscape,
  tabletPortrait,
  mobile,
  children,
  ...props
}) => {
  const theme = useTheme();
  const updatedTheme = updateThemeColumns(theme, {
    desktop,
    tabletLandscape,
    tabletPortrait,
    mobile,
  });
  return (
    <GridItemWrapper
      desktop={desktop}
      tabletLandscape={tabletLandscape}
      tabletPortrait={tabletPortrait}
      mobile={mobile}
      {...componentProps(props)}>
      <ThemeProvider theme={updatedTheme}>{children}</ThemeProvider>
    </GridItemWrapper>
  );
};

export default applyComponentTheme(GridItem, 'GridItem');
